// Componente ItemRadio - Botón de radio personalizado
// Reutiliza la lógica y estética de amarsi-app para la web

import React from 'react';
import { FiCheck } from 'react-icons/fi';

/**
 * Componente ItemRadio
 * 
 * Botón de radio personalizado con diseño consistente para el formulario de registro
 * 
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.active - Si está seleccionado
 * @param {string} props.labelText - Texto a mostrar
 * @param {Function} props.onPress - Función al hacer clic
 * @param {string} props.className - Clases adicionales
 * @returns {JSX.Element} Botón de radio personalizado
 */
const ItemRadio = ({ 
  active = false, 
  labelText = '', 
  onPress = () => {}, 
  className = '' 
}) => {
  return (
    <button
      type="button"
      onClick={onPress}
      className={`
        w-full p-4 rounded-xl border-2 transition-all duration-200
        flex items-center space-x-3 text-left
        ${active 
          ? 'border-primary-500 bg-primary-50 dark:bg-primary-900/20 dark:border-primary-400' 
          : 'border-neutral-200 dark:border-neutral-600 bg-white dark:bg-neutral-700 hover:border-neutral-300 dark:hover:border-neutral-500'
        }
        ${className}
      `}
    >
      {/* Círculo del radio button */}
      <div className={`
        w-5 h-5 rounded-full border-2 flex items-center justify-center
        transition-all duration-200 flex-shrink-0
        ${active 
          ? 'border-primary-500 bg-primary-500' 
          : 'border-neutral-300 dark:border-neutral-500'
        }
      `}>
        {active && (
          <div className="w-2 h-2 rounded-full bg-white">
            <FiCheck className="w-full h-full text-white" />
          </div>
        )}
      </div>
      
      {/* Texto de la etiqueta */}
      <span className={`
        text-base font-medium
        ${active 
          ? 'text-primary-700 dark:text-primary-300' 
          : 'text-neutral-700 dark:text-neutral-300'
        }
      `}>
        {labelText}
      </span>
    </button>
  );
};

export default ItemRadio;
